import * as React from 'react';
export function LoadingSkeleton() {
    return (React.createElement("div", { className: 'geposit-loading-skeleton' },
        React.createElement("i", { className: 'fa-regular fa-circle-dashed fa-spin' })));
}
